import * as R from 'ramda'
import {OrderCreate} from './OrderCreate'
import {PositionCreate} from './PositionCreate'
import {Step1Data} from '../Pages/OrderCreate/Step1/Step1State'
import {Step2Data} from '../Pages/OrderCreate/Step2/Step2State'
import {Step3Data} from '../Pages/OrderCreate/Step3/Step3State'

export interface OrderCreateWithDetails {
    readonly order: OrderCreate
    readonly positions: PositionCreate[]
}

export function fromSteps(
    step1: Step1Data,
    step2: Step2Data,
    step3: Step3Data,
): OrderCreateWithDetails {
    return {
        order: {
            transactionNumber: step1.transactionNumber,
            customerId: step1.customer.id,
            bpsUserId: step1.bpsUser.id,
            companyId: step1.company.id,
            invoiceName1: step3.invoiceName1,
            invoiceName2: step3.invoiceName2,
            invoiceName3: step3.invoiceName3,
            invoiceName4: step3.invoiceName4,
            invoiceStreet: step3.invoiceStreet,
            invoiceHouseNumber: step3.invoiceHouseNumber,
            invoiceZipCode: step3.invoiceZipCode,
            invoiceCity: step3.invoiceCity,
            invoiceCountry: step3.invoiceCountry.code,
            vatId: step3.vatId,
            deliveryName1: step3.deliveryName1,
            deliveryName2: step3.deliveryName2,
            deliveryName3: step3.deliveryName3,
            deliveryName4: step3.deliveryName4,
            deliveryFloor: step3.deliveryFloor,
            deliveryRoom: step3.deliveryRoom,
            deliveryStreet: step3.deliveryStreet,
            deliveryHouseNumber: step3.deliveryHouseNumber,
            deliveryZipCode: step3.deliveryZipCode,
            deliveryCity: step3.deliveryCity,
            deliveryCountry: step3.deliveryCountry.code,
            shippingMethod: step3.shippingMethod,
        },
        positions:
            R.map(
                position => ({
                    productId: position.product.productId,
                    amount: position.amount,
                }),
                step2.positions,
            ),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderCreateWithDetails.ts